<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'RegisterSecondaryProtocol',
    methods: {
      showRegisterSecondaryModal() {
      
      },
    },
    mounted() {
      window.livewire.on('protocolRegistered', (url) => {
        $('#register-protocol-modal').modal('hide')
        
        if(url) {
          location.href = url
        }
      })
    }
  }
</script>
